import { useEffect, useRef } from "react";
import { FormGroup, Label, Col, Row } from "reactstrap";
import { groupBys } from "../constants/quoteOverviewConstants";
import CustomSelect from "../../../components/CustomSelect";

const QuoteOverviewGroupBys = ({id, groupBySection, groupByColumn1, groupByColumn2, setGroupBySection, setGroupByColumn1, setGroupByColumn2}) => {
    const SETTINGS_KEY_PREFIX = "quoteOverviewTableGroupSettings_" + id + "_"

    const groupBySectionOptions = groupBys.map(g => ({ value: g.key, label: g.label }))
    const groupByColumn1Options = groupBys.filter(x => x.key !== groupBySection).map(g => ({ value: g.key, label: g.label }))
    const groupByColumn2Options = [{ value: "None", label: "-None-" },...groupBys.filter(x => x.key !== groupBySection && x.key !== groupByColumn1).map(g => ({ value: g.key, label: g.label }))]

    // Utility function to load from local storage
    const getFromLS = (key) => {
        if (typeof window !== "undefined") {
            let value = localStorage.getItem(SETTINGS_KEY_PREFIX + key)
            console.log("getFromLS", SETTINGS_KEY_PREFIX + key, value)
            return value ? value : null 
        }
        return null
    }

    // Utility function to save to local storage
    const saveToLS = (key, value) => {
        if (typeof window !== "undefined") {
            localStorage.setItem(SETTINGS_KEY_PREFIX + key, value)
            console.log("saveToLS", SETTINGS_KEY_PREFIX + key, value)
        }
    }

    useEffect(() => {
        const savedGroupBySection = getFromLS("groupBySection")
        const savedGroupByColumn1 = getFromLS("groupByColumn1")
        const savedGroupByColumn2 = getFromLS("groupByColumn2")

        if (savedGroupByColumn2) setGroupByColumn2(savedGroupByColumn2)
        if (savedGroupByColumn1) setGroupByColumn1(savedGroupByColumn1)
        if (savedGroupBySection) setGroupBySection(savedGroupBySection)
    }, []);

   console.log("groupBy1", groupBySection)

    return (
        <>
            <Row>
                <Col sm={2}>
                    <FormGroup>
                        <Label for="sections">Sections</Label>
                        <CustomSelect 
                            id="sections"
                            name="sections"
                            isSearchable={true}
                            options={groupBySectionOptions}
                            onChange={(selectedOption) => {
                                saveToLS("groupBySection", selectedOption.value)
                                setGroupBySection(selectedOption.value)

                                if (selectedOption.value === groupByColumn1) {
                                    saveToLS("groupByColumn1", groupByColumn1Options[0]?.value)
                                    setGroupByColumn1(groupByColumn1Options[0]?.value)
                                }
                                if (selectedOption.value === groupByColumn2) {
                                    saveToLS("groupByColumn2", groupByColumn2Options[0]?.value)
                                    setGroupByColumn2(groupByColumn2Options[0]?.value)
                                }
                            }}
                            value={groupBySection}
                            invalid={false}
                        />
                    </FormGroup>
                </Col>
                <Col sm={2}>
                    <FormGroup>
                        <Label for="groupCol1">Group By Column 1</Label>
                        <CustomSelect 
                            id="groupCol1"
                            name="groupCol1"
                            isSearchable={true}
                            options={groupByColumn1Options}
                            onChange={(selectedOption) => {
                                saveToLS("groupByColumn1", selectedOption.value)
                                setGroupByColumn1(selectedOption.value)
                                if (selectedOption.value === groupByColumn2) {
                                    saveToLS("groupByColumn2", groupByColumn2Options[0]?.value)
                                    setGroupByColumn2(groupByColumn2Options[0]?.value)
                                }
                            }}
                            value={groupByColumn1}
                            invalid={false}
                        />
                    </FormGroup>
                </Col>
                <Col sm={2}>
                    <FormGroup>
                        <Label for="groupCol2">Group By Column 2</Label>
                        <CustomSelect 
                            id="groupCol2"
                            name="groupCol2"
                            isSearchable={true}
                            options={groupByColumn2Options}
                            onChange={(selectedOption) => {
                                saveToLS("groupByColumn2", selectedOption.value)
                                setGroupByColumn2(selectedOption.value)
                            }}
                            value={groupByColumn2}
                            invalid={false}
                            sortItems={false}
                        />
                    </FormGroup>
                </Col>
            </Row>
        </>

    );
}
export default QuoteOverviewGroupBys;